(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sinbne-responsive-banner"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sinbne-story-carousel')){
  customElements.define('sinbne-story-carousel',class extends HTMLElement{
    connectedCallback(){
      this.abort?.abort();
      this.abort=new AbortController();
      const signal=this.abort.signal;
      this.slides=Array.from(this.querySelectorAll('.sinbne-story__slide'));
      this.dots=Array.from(this.querySelectorAll('[data-slide]'));
      this.controls=this.querySelector('.sinbne-story__controls');
      this.toggle=this.querySelector('[data-toggle]');
      this.status=this.querySelector('[data-status]');
      this.index=0;
      this.sequence=0;
      this.hovered=false;
      this.focused=false;
      this.timer=null;
      if(this.slides.length<2)return;
      this.motion=matchMedia('(prefers-reduced-motion: reduce)');
      this.paused=this.dataset.autoplay!=='true'||this.motion.matches;
      this.controls.hidden=false;
      this.querySelector('[data-next]').addEventListener('click',()=>this.show(this.index+1),{signal});
      this.querySelector('[data-previous]').addEventListener('click',()=>this.show(this.index-1),{signal});
      this.dots.forEach(dot=>dot.addEventListener('click',()=>this.show(Number(dot.dataset.slide)),{signal}));
      this.toggle.addEventListener('click',()=>{this.paused=!this.paused;this.updateToggle();this.schedule();},{signal});
      this.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'){this.hovered=true;this.schedule();}},{signal});
      this.addEventListener('pointerleave',()=>{this.hovered=false;this.schedule();},{signal});
      this.addEventListener('focusin',()=>{this.focused=true;this.schedule();},{signal});
      this.addEventListener('focusout',event=>{if(!this.contains(event.relatedTarget)){this.focused=false;this.schedule();}},{signal});
      this.controls.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();this.show(this.index+(event.key==='ArrowRight'?1:-1));}},{signal});
      const track=this.querySelector('.sinbne-story__track');
      track.addEventListener('pointerdown',event=>{if(event.pointerType==='touch')this.touch={x:event.clientX,y:event.clientY};},{signal});
      track.addEventListener('pointerup',event=>{if(!this.touch)return;const dx=event.clientX-this.touch.x;const dy=event.clientY-this.touch.y;this.touch=null;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.3){this.suppressClick=true;this.show(this.index+(dx<0?1:-1));}},{signal});
      track.addEventListener('pointercancel',()=>{this.touch=null;},{signal});
      track.addEventListener('click',event=>{if(this.suppressClick){event.preventDefault();this.suppressClick=false;}},{capture:true,signal});
      document.addEventListener('visibilitychange',()=>this.schedule(),{signal});
      this.motion.addEventListener('change',event=>{if(event.matches)this.paused=true;this.updateToggle();this.schedule();},{signal});
      document.addEventListener('shopify:block:select',()=>{this.paused=true;this.updateToggle();this.schedule();},{signal});
      this.updateToggle();
      this.schedule();
    }
    disconnectedCallback(){this.abort?.abort();clearTimeout(this.timer);this.sequence++;}
    updateToggle(){
      this.toggle.setAttribute('aria-label',this.paused?this.toggle.dataset.playLabel:this.toggle.dataset.pauseLabel);
      this.toggle.setAttribute('aria-pressed',String(this.paused));
      this.toggle.querySelector('[data-play-icon]').toggleAttribute('hidden',!this.paused);
      this.toggle.querySelector('[data-pause-icon]').toggleAttribute('hidden',this.paused);
      this.status.setAttribute('aria-live',this.paused?'polite':'off');
    }
    schedule(){
      clearTimeout(this.timer);
      if(this.paused||this.hovered||this.focused||document.hidden||!this.isConnected)return;
      this.timer=setTimeout(()=>this.show(this.index+1),Math.max(5000,Number(this.dataset.interval)||7000));
    }
    async show(next){
      clearTimeout(this.timer);
      const target=(next+this.slides.length)%this.slides.length;
      if(target===this.index){this.schedule();return;}
      const sequence=++this.sequence;
      const image=this.slides[target].querySelector('img');
      image.loading='eager';
      try{await image.decode();}catch{}
      if(!this.isConnected||sequence!==this.sequence)return;
      this.slides.forEach((slide,index)=>{
        const active=index===target;
        slide.classList.toggle('is-active',active);
        slide.inert=!active;
        slide.setAttribute('aria-hidden',String(!active));
        this.dots[index].setAttribute('aria-current',String(active));
      });
      this.index=target;
      this.status.textContent=this.slides[target].getAttribute('aria-label');
      this.schedule();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
